import { jsx, Fragment } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

var checkIsStandalone = function checkIsStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches;
};

var useStatistic = function useStatistic(_a) {
  var path = _a.path,
      headers = _a.headers,
      from = _a.from,
      timeoutMinutes = _a.timeoutMinutes;
  useLocation().pathname;

  function getSearchParams() {
    var isPWA = checkIsStandalone();
    var fromValue = isPWA ? 'pwa' : 'browser';
    return from ? "?from=".concat(fromValue) : '';
  }

  useEffect(function () {
    var _a = window.location,
        hostname = _a.hostname,
        pathname = _a.pathname;
    var referer = sessionStorage.getItem('referer');
    var params = {
      referer: (referer != null ? hostname + referer : '-') + getSearchParams(),
      url: hostname + pathname + getSearchParams()
    };

    if (referer !== pathname) {
      axios.put(path, params, {
        headers: headers !== null && headers !== void 0 ? headers : {}
      }).catch(function (e) {
        throw new Error(e.message);
      });
      sessionStorage.setItem('referer', pathname);
    }
  }, [location.pathname]);
  useEffect(function () {
    var interval;

    if (timeoutMinutes) {
      interval = setInterval(function () {
        var _a = window.location,
            hostname = _a.hostname,
            pathname = _a.pathname;
        var params = {
          url: hostname + pathname + getSearchParams()
        };
        axios.put(path, params, {
          headers: headers !== null && headers !== void 0 ? headers : {}
        }).catch(function (e) {
          throw new Error(e.message);
        });
      }, timeoutMinutes * 60 * 1000);
    }

    return function () {
      clearInterval(interval);
    };
  }, []);
};

var Statistic = function Statistic(params) {
  useStatistic(params);
  return jsx(Fragment, {});
};

var withStatistic = function withStatistic(WrappedComponent, params) {
  return function () {
    useStatistic(params);
    return jsx(WrappedComponent, {});
  };
};

export { Statistic, useStatistic, withStatistic };